import { motion, AnimatePresence } from "framer-motion";
import React from "react";

export const LogoContainer = () => {
  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        className="logo-container"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -100 }}
        transition={{ duration: 0.5 }}
      >
        <img
          style={{ width: "auto", height: "50px" }}
          src="/assets/logos/wompi.svg"
          alt="Wompi Logo"
        />
      </motion.div>
    </AnimatePresence>
  );
};
